var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"button button_red",attrs:{"disabled":_vm.isLoading}},[_vm._v(" "+_vm._s(_vm.isLoading ? "Please wait..." : _vm.text)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }